import { createCoinbaseWalletSDK } from "@coinbase/wallet-sdk";

const sdk = createCoinbaseWalletSDK({
  appName: "PlanetJ",
  darkMode: false,
  appLogoUrl: "https://d1pyi77ms1fhr5.cloudfront.net/assets/pngs/logo.png",
  jsonRpcUrl: `https://mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_PROJECT_ID}`,
  chainId: 1,
});

export const coinbaseProvider = sdk;

export const connectCoinbase = async () => {
  try {
    const accounts = await sdk.getProvider().request({
      method: "eth_requestAccounts",
    });
    return accounts.length > 0 ? accounts[0] : null;
  } catch (error) {
    console.error("Coinbase connection failed:", error);
    // throw error;
  }
};

export const disconnectCoinbase = async () => {
  try {
    await sdk.getProvider().disconnect();
  } catch (error) {
    console.error("Error disconnecting Coinbase:", error);
  }
};
